import { render, staticRenderFns } from "./EndCardEditWindow.vue?vue&type=template&id=e52f4524&scoped=true&"
import script from "./EndCardEditWindow.vue?vue&type=script&lang=ts&"
export * from "./EndCardEditWindow.vue?vue&type=script&lang=ts&"
import style0 from "./EndCardEditWindow.vue?vue&type=style&index=0&id=e52f4524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52f4524",
  null
  
)

export default component.exports